export default __webpack_public_path__ + "static/media/projectImg.4f9a9448.png";